// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2cxg3","ranges":"BmiRanges_ranges__ZhWz4"};